<template>
  <div>
    <div>
      <div class="type-heading-sm">
        Fråga {{ props.questionNumber }}
      </div>
      <div>{{ props.questionText }}</div>
      <div class="type-heading-sm mt-xs">Svar</div>
      <div>{{ props.questionAnswer }}</div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  questionNumber: string;
  questionText: string;
  questionAnswer: string | undefined | null;
}>();
</script>
